
// Section nav: scroll to anchor + set active.
const navLinks = document.querySelectorAll('.settings-nav-link');
navLinks.forEach((a) => {
  a.addEventListener('click', (e) => {
    e.preventDefault();
    const target = document.querySelector(a.getAttribute('href'));
    if (target) {
      navLinks.forEach((l) => l.classList.remove('active'));
      a.classList.add('active');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// Auto-highlight nav link based on scroll position.
const sections = document.querySelectorAll('.settings-section');
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const id = entry.target.id;
      navLinks.forEach((l) => l.classList.toggle('active', l.getAttribute('href') === '#' + id));
    }
  });
}, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
sections.forEach((s) => observer.observe(s));
